import { Button, TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsPencilFill, BsPenFill } from "react-icons/bs";

interface IAmountInputProps {
    onChange?: (newVal: number, increment:boolean) => void;
}

const AmountInput = (props:IAmountInputProps) => {

    const { t } = useTranslation();

    const inputRef = useRef<HTMLInputElement>(null);


    const handleIncrement = (newVal:number) => {
        if(props.onChange){
            props.onChange(newVal, true);
        }
    }
    const handleSetAmount = (newVal:number) => {
        if(props.onChange){
            props.onChange(newVal, false);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
       
            const value = e.currentTarget.value;
            const intVal = parseInt(value);

            if(!isNaN(intVal)){
                handleSetAmount(intVal);
                console.log("onEnter", intVal);
                
                
            }

            setShowInput(false);
        }
        else if (e.key === 'Escape') {
            setShowInput(false);
        }

    };

    const handleBlur = () => {
        if (inputRef.current) {
            const value = inputRef.current.value;
            const intVal = parseInt(value);

            if(!isNaN(intVal)){
                handleSetAmount(intVal);
                console.log("onBlur", intVal);

            }

            setShowInput(false);
        }
    };

    const [showInput, setShowInput] = useState<boolean>(false);

    return (
        <div className="flex flex-row gap-4  items-center">
            <Button 
                variant="outlined" 
                onClick={(event) => {
                    handleIncrement(1);
                    event.preventDefault();
                    event.stopPropagation();
                }}

                size="small" 
                className="min-w-[60px] px-4 font-medium rounded-lg transition-colors duration-200"
                sx={{ 
                    height: '48px',
                    marginTop: "16px",
                    marginBottom: "8px"
                }}
            >
                +1
            </Button>
            <Button 
                variant="outlined" 
                onClick={(event) => {
                    handleIncrement(5);
                    event.preventDefault();
                    event.stopPropagation();
                }}

                size="small" 
                className="min-w-[60px] px-4 font-medium rounded-lg transition-colors duration-200"
                sx={{ 
                    height: '48px',
                    marginTop: "16px",
                    marginBottom: "8px"
                }}
            >
                +5
            </Button>
            <Button 
                variant="outlined" 
                onClick={(event) => {
                    handleIncrement(10);
                    event.preventDefault();
                    event.stopPropagation();
                }}

                size="small" 
                className="min-w-[60px] px-4 font-medium rounded-lg transition-colors duration-200"
                sx={{ 
                    height: '48px',
                    marginTop: "16px",
                    marginBottom: "8px"
                }}
            >
                +10
            </Button>


            <div className="shrink-0">
                {showInput
                    ?
                    <TextField
                        inputRef={inputRef}
                        autoFocus
                        label={t("common:customAmountLabel")}
                        variant="outlined"         // you can also use "filled" or "standard"
                        size="small"
                        // fullWidth
                        margin="normal"
                        type="text"                // let inputMode pattern handle numeric pad
                        inputMode="numeric"
                        // pattern="[0-9]*"
                        // onBlur={handleBlur}
                        // onKeyDown={handleKeyDown}

                        inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            onBlur: handleBlur,
                            onKeyDown: handleKeyDown
                        }}
                        className="h-12 min-w-[60px] w-[80px] px-4 font-medium rounded-lg transition-colors duration-200"

                        sx={{
                            '& .MuiInputBase-root': { height: '48px' },
                        }}
                    />
                        

                    :
                    <Button 
                        variant="outlined" 
                        size="small" 
                        className="h-12 w-20 px-3 border border-gray-300 rounded-lg text-center"

                        onClick={(event) => {
                            // handleOnChange()

                            setShowInput(true);

                            event.preventDefault();
                            event.stopPropagation();
                        }}

                        sx={{ 
                            height: '48px',
                            marginTop: "16px",
                            marginBottom: "8px"
                        }}
                    >
                        <BsPencilFill />
                    </Button>
                }



            </div>

        </div>
    )
};

export default AmountInput;
